module.exports = __webpack_public_path__ + "img/lpfv-sp-2000.bbd01f6a.png";